import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import { HttpUtil } from "../../Utils/http-utils";
import { getDispatch, getSnackbarSuccess, isLoadingAction } from "../../Utils/helper";
import {
  getToken,
  GET_PAYOUT_DETAILS,
  getNetworkMenuId,
  GET_TOTAL_COUNT,
  GET_USSAGECOVERAGE_DETAILS,
  GET_WIDGET_DETAILS,
  GET_ADOPTIONANALYSIS_DETAILS,
  GET_USSAGECOVERAGE_FILTERS,
  GET_USSAGECOVERAGE_DCPIC_IMAGES,
  GET_ADDITIONAL_FILTER,
} from "../../Utils/types";

export const getPayoutDetailsAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/GetProvidersPayoutDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_PAYOUT_DETAILS,
        res?.data?.results?.lstPayoutDetails,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_PAYOUT_DETAILS, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};
export const getWidgetAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/GetWidget`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_WIDGET_DETAILS, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_WIDGET_DETAILS, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};
export const GetAdditionalFilterNetwork = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/GetAdditionalFilterNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_ADDITIONAL_FILTER, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_ADDITIONAL_FILTER, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};
export const SendCommunicationToProviders = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/SendCommunicationToProviders`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
      isLoadingAction(false, dispatch);
    
    return res
  });
};

export const getUsageCoverageDetailsAction = (e,loading) => (dispatch) => {
  if(loading === "loading"){
    isLoadingAction(false, dispatch);
  } else {
    isLoadingAction(true, dispatch);
  }
  const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/GetNetworkUrgencyDetails`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_USSAGECOVERAGE_DETAILS,
        res?.data?.results?.lstDetails,
        dispatch
      );
      getDispatch(
        GET_USSAGECOVERAGE_DCPIC_IMAGES,
        res?.data?.results?.lstDCPicsImage,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_USSAGECOVERAGE_DETAILS, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
    return res
  });
};
export const GetNetworkClientCoverageDetails = (e,loading) => (dispatch) => {
  if(loading === "loading"){
    isLoadingAction(false, dispatch);
  } else {
    isLoadingAction(true, dispatch);
  }
  const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/GetNetworkClientCoverageDetails`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_USSAGECOVERAGE_DETAILS,
        res?.data?.results?.lstDetails,
        dispatch
      );
      getDispatch(
        GET_USSAGECOVERAGE_DCPIC_IMAGES,
        res?.data?.results?.lstDCPicsImage,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_USSAGECOVERAGE_DETAILS, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
    return res
  });
};

export const getUsageAndCoverageFiltersAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/GetUsageAndCoverageFiltersNetwork`;
  return HttpUtil.makePOST(
    url,
    {
      clientId: 0,
      clientName: "",
      BusinessType:e,
    },
    {
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_USSAGECOVERAGE_FILTERS, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_USSAGECOVERAGE_FILTERS, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getAdoptionAnalysisAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/GetAdoptionAnalysisDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_ADOPTIONANALYSIS_DETAILS,
        res?.data?.results?.lstMainAdoptionAnalysis,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_ADOPTIONANALYSIS_DETAILS, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getPayoutDetailsExcelAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/GetExportToPDFPayoutDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  });
};

export const getProviderScoreStatisticsNetworkAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/GetProviderScoreStatisticsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  });
};
